module.exports = __webpack_public_path__ + "static/img/program_webpage_img.png.9eeb0638.png";